<div class="p-6 space-y-6">
  <div class="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
    <div>
      <h1 class="text-2xl font-bold">{{ report()?.title || 'Reports' }}</h1>
      <p class="text-sm opacity-70">
        {{ report()?.subtitle || 'Loading report data' }}
      </p>
    </div>

    <div class="flex flex-wrap items-center gap-2">
      <select
        class="select select-bordered select-sm w-40"
        [ngModel]="selectedStoreId()"
        (ngModelChange)="onStoreChange($event)"
      >
        <option [ngValue]="null">All Stores</option>
        @for (store of stores(); track store.id) {
          <option [ngValue]="store.id">{{ store.name }}</option>
        }
      </select>

      <select
        class="select select-bordered select-sm w-40"
        [ngModel]="selectedRange()"
        (ngModelChange)="onRangeChange($event)"
      >
        <option [ngValue]="1">Today</option>
        <option [ngValue]="2">Yesterday + Today</option>
        <option [ngValue]="7">Last 7 Days</option>
        <option [ngValue]="30">Last 30 Days</option>
        <option [ngValue]="90">Last 90 Days</option>
        <option [ngValue]="-1">Custom Range</option>
      </select>

      @if (selectedRange() === -1) {
        <div class="flex items-center gap-2">
          <input 
            type="date" 
            class="input input-bordered input-sm w-36" 
            [ngModel]="startDate()" 
            (ngModelChange)="startDate.set($event); onCustomDateChange()"
          >
          <span class="text-xs opacity-50">to</span>
          <input 
            type="date" 
            class="input input-bordered input-sm w-36" 
            [ngModel]="endDate()" 
            (ngModelChange)="endDate.set($event); onCustomDateChange()"
          >
        </div>
      }

      <button class="btn btn-sm btn-outline" type="button" (click)="loadReport()">
        <i class="fa-solid fa-rotate-right"></i>
        Refresh
      </button>

      <button
        class="btn btn-sm btn-primary" type="button" (click)="exportAll()"
        [disabled]="!hasRows() || isLoading() || exporting()">
        {{ exporting() ? exportProgress() : 'Export all matching' }}
      </button>
      <button
        class="btn btn-sm btn-primary"
        type="button"
        (click)="exportCsv()"
        [disabled]="!hasRows() || isLoading() || exporting()"
      >
        <i class="fa-solid fa-download"></i>
        Export current page
      </button>
    </div>
  </div>

  @if (error()) {
  <div class="alert alert-error">
    <i class="fa-solid fa-circle-exclamation"></i>
    <span>{{ error() }}</span>
  </div>
  }

  @if (isLoading()) {
  <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
    @for (item of [1, 2, 3, 4]; track item) {
    <div class="border border-base-300 bg-base-100 rounded-lg p-5">
      <div class="skeleton h-4 w-24 mb-4"></div>
      <div class="skeleton h-8 w-32"></div>
    </div>
    }
  </div>

  <div class="border border-base-300 bg-base-100 rounded-lg p-5 space-y-3">
    @for (item of [1, 2, 3, 4, 5, 6]; track item) {
    <div class="skeleton h-12 w-full"></div>
    }
  </div>
  } @else if (report()) {
  <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
    @for (card of report()!.cards; track card.label) {
    <div class="border rounded-lg p-5" [ngClass]="cardClass(card.tone)">
      <p class="text-sm opacity-70">{{ card.label }}</p>
      <h2 class="text-2xl font-bold mt-2">{{ card.value }}</h2>
    </div>
    }
  </div>

  @if (paginatedRows().length > 0) {
    <div class="border border-base-300 bg-base-100 rounded-lg p-5 mb-4 shadow-sm">
      <div class="relative w-full h-64">
        <canvas #reportChart></canvas>
      </div>
    </div>
  }

  <div class="border border-base-300 bg-base-100 rounded-lg overflow-hidden">
    <div class="overflow-x-auto">
      <table class="table table-zebra">
        <thead>
          <tr>
            @for (column of report()!.columns; track column.key) {
            <th
              [class.text-right]="column.align === 'right'"
              [class.text-center]="column.align === 'center'"
            >
              {{ column.label }}
            </th>
            }
          </tr>
        </thead>
        <tbody>
          @if (paginatedRows().length > 0) {
          @for (row of paginatedRows(); track $index) {
          <tr>
            @for (column of report()!.columns; track column.key) {
            <td
              [class.text-right]="column.align === 'right'"
              [class.text-center]="column.align === 'center'"
            >
              {{ cell(row, column) }}
            </td>
            }
          </tr>
          }
          } @else {
          <tr>
            <td [attr.colspan]="report()!.columns.length">
              <div class="py-12 text-center opacity-70">
                No data found for the selected range.
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="flex items-center justify-between">
    <button
      class="btn btn-sm btn-outline"
      type="button"
      (click)="prevPage()"
      [disabled]="currentPage() === 1"
    >
      Previous
    </button>

    <span class="text-sm">
      Page {{ currentPage() }} of {{ totalPages() }} · {{ report()!.total }} records
    </span>

    <button
      class="btn btn-sm btn-outline"
      type="button"
      (click)="nextPage()"
      [disabled]="currentPage() === totalPages()"
    >
      Next
    </button>
  </div>
  }
</div>
